import { render, staticRenderFns } from "./Repair.vue?vue&type=template&id=b0ecd286&scoped=true"
import script from "./Repair.vue?vue&type=script&lang=js"
export * from "./Repair.vue?vue&type=script&lang=js"
import style0 from "./Repair.vue?vue&type=style&index=0&id=b0ecd286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ecd286",
  null
  
)

export default component.exports